var exports = {
  "b7": "ChartCardDialogBody__qGPiNr",
  "nO": "ChartCardDialogRow__vbZYOa",
  "m7": "ChartCardDialogColGrow__WhNwQ7",
  "RE": "ChartCardDialogSwitchLabel__jAvWkI",
  "DF": "ChartCardDialogSwitchCaption__H2rPnx",
};

module.exports = exports;
